/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { LuisConstants } from 'src/core/utils/LuisConstants';
import { ModelType } from 'src/luis/types/ModelType';
import { EntityStore } from 'src/luis/types/stores/entities/EntityStore';
import { SimpleEntityStore } from 'src/luis/types/stores/entities/SimpleEntityStore';

/**
 * Utils function to get limits for creation of new entities
 */
export const getSimpleEntityLimits = (entityStore: EntityStore, level: number) => {
    const isMLEntity = entityStore.typeId === ModelType.Simple;

    const numberOfChildren = isMLEntity && (<SimpleEntityStore>entityStore).children.length;

    const canHaveChildrenBasedOfDepth = isMLEntity && level < LuisConstants.ResourceLimits.EntityDepthLimit;
    const canHaveChildrenBasedOfCurrentCount = numberOfChildren < LuisConstants.ResourceLimits.EntityPerParentLimit;

    return { canHaveChildrenBasedOfDepth, canHaveChildrenBasedOfCurrentCount };
};
